<template>
  <div>

    <v-container fluid class="white elevation-3 margen d-flex justify-space-around">
      <v-row class="pb-3 d-flex justify-space-around">
        <v-col cols="12" sm="12" md="4" class="ma-auto">
          <h1>Resguardo</h1>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="3" class="ma-auto mb-n6"> -->
          <!-- <v-text-field dense outlined label="Buscar Maquinado" v-model="buscador" class="mx-2"/> -->
        <!-- </v-col> -->
        <v-col cols="12" sm="12" md="4" class="ma-auto">
          <v-btn class="mt-2 success darken-1" small text to="/crearSalidaProceso">Crear Resguardo</v-btn>
        </v-col>
      </v-row>
    </v-container>

      <v-card class="ma-3">
        <v-row class="mx-3 my-3">
          <v-btn class="success darken-1 ma-auto mt-2" small text @click="getItems()">Actualizar</v-btn>
          <v-spacer></v-spacer>
          <v-text-field class="ma-3" v-model="buscador" label="Buscar" append-icon="mdi-magnify" single-line hide-details/>
        </v-row>
        <v-data-table :items="items" :headers="columnas" :loading="cargando" :search="buscador" item-key="MAQUINADO_ID" class="tamTexto">
          
          <template v-slot:[`item.FECHA`]="{ item }">
            {{item.FECHA.split(' ')[0] | item.FECHA}}
          </template>
          
          <template v-slot:[`item.ESTATUS`]="{ item }">
            {{estatus(item)}}
          </template>
          
          <template v-slot:[`item.accionOpciones`]="{ item }">
            <v-icon @click="$router.push(`/editarSalidaProceso/${item.RESGUARDO_ID}`)" color="amber accent-4">mdi-pencil</v-icon>
          </template>

          <template v-slot:[`item.accionEliminar`]="{ item }">
            <v-icon :disabled="item.ESTATUS == 'T' || item.ESTATUS =='B'" @click="cambiarEstatus(item)" color="red ">mdi-cog-transfer</v-icon>
          </template>

          <template slot="no-data">
            <v-alert class="my-2" :value="true" type="info" color="orange darken-1" >
              <span class="font-weight-medium"> No se encontro informacion para mostrar.</span>
            </v-alert>
          </template>

        </v-data-table>
      </v-card>
    </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
  // ------------------------------------------------------------------------------
  data() {
    return {

      // Tabla items
      items:[],
      buscador:'',
      columnas:[
        {text: "Folio",   value:"FOLIO",                          class:'primary lighten-1 white--text'},
        {text: "Producto",value:"ANOMBRE",                        class:'primary lighten-1 white--text'},
        {text: "Fecha",   value:"FECHA",                          class:'primary lighten-1 white--text'},
        {text: "Estatus", value:"ESTATUS",                        class:'primary lighten-1 white--text'},
        {text: "Opciones",value:"accionOpciones",sortable:false,  class:'primary lighten-1 white--text'},
        {text: "Accion",  value:"accionEliminar",sortable:false,  class:'primary lighten-1 white--text'},
      ],
      cargando:false,
    }
  },

  // ------------------------------------------------------------------------------
  computed: {
    ...mapGetters(['getURLAPI','getRolesUsuario','getUsuario']),

  },

  // ------------------------------------------------------------------------------
  methods: {
    // ------------------------------------------------------------------------------
    // almacenDestino( item ){
    //   let destino
    // },

    // ------------------------------------------------------------------------------
    estatus(item){
      let msg;
      switch (item.ESTATUS) {
        case 'A':
          msg = "ACTIVO"
          break;

        case 'B':
          msg = "BAJA"
          break;

        case 'T':
          msg = "TERMINADO"
          break;

        case 'M':
          msg = "ENVIADO MICROSIP"
          break;

        default:
          break;
      }
      return msg;
    },

    // ------------------------------------------------------------------------------
    async getItems(){
      this.cargando = true;
      this.items =[];

      if (this.getRolesUsuario.includes('SA') || this.getRolesUsuario.includes('ADMIN')) {
        
        this.items = (await axios.get(`${this.getURLAPI}/Show/allResguardo`)).data
      } else {
        let datosForm = new FormData();
        datosForm.append("USUARIO_CREADOR",this.getUsuario);
        this.items = (await axios.post(`${this.getURLAPI}/Show/allResguardoUsuario`,datosForm)).data
      }
      this.cargando = false;
    },

    // ------------------------------------------------------------------------------
    cambiarEstatus( item ){
      let confirm = window.confirm(`¿Seguro que deseas eliminar el Proceso con folio: ${item.FOLIO}?`);

      if(confirm){
        let datosForm = new FormData();
        datosForm.append("RESGUARDO_ID" , item.RESGUARDO_ID);
  
        axios.post(`${this.getURLAPI}/SalidaProcesos/cambiarEstatus`,datosForm)
        .then( ({data}) => {
          // console.log(data);
          this.$root.vtoast.show(
            { 
              message: data.MSG, 
              color:data.STATUS=="OK" ? 'success darken-1' : "red darken-1", 
              timer:10000,
              icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' 
            } 
          )
          this.getItems();
        })

      }

    },

  },

  // ------------------------------------------------------------------------------
  created() {
    document.title = "Salida Proceso | Bombas y Suministros del Norte"
    this.getItems();
  },
}
</script>

<style>

</style>